import * as React from "react";
const SvgCancel = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M5.83325 5.83331L14.1666 14.1666M14.1666 5.83331L5.83325 14.1666"
    }
  )
);
export default SvgCancel;
